/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { getTheme, FontSizes, IStackStyles, IStackTokens, ITextStyles } from "@fluentui/react";

const theme = getTheme();

/**
 * Styling for the wrapper stack
 */
export const wrapperStackStyles = (): IStackStyles => {
  return {
    root: {
      padding: "0 3.25rem 0 1.25rem",
    },
  };
};

/**
 * Styling for the name info stack
 */
export const nameInfoStackStyles = (): IStackStyles => {
  return {
    root: {
      padding: "1.5rem",
      backgroundColor: theme.palette.white,
      borderRadius: "0.5rem",
    },
  };
};

/**
 * Styling for the name text
 */
export const nameTextStyles = (): ITextStyles => {
  return { root: { fontSize: FontSizes.size20, fontWeight: 600 } };
};

/**
 * Styling for the name text
 */
export const isCompetitorTextStyles = (): ITextStyles => {
  return { root: { fontSize: FontSizes.size20, fontWeight: 600, color: "red" } };
};

/**
 * Styling for the email text
 */
export const emailTextStyles = (): ITextStyles => {
  return { root: { fontSize: FontSizes.size16, fontWeight: 400 } };
};

/**
 * Styling for the private profile text
 */
export const privateProfileTextStyles = (): ITextStyles => {
  return {
    root: {
      fontSize: FontSizes.size16,
      lineHeight: "1.375 rem",
      fontWeight: 600,
      color: "#FF0000",
    },
  };
};

/**
 * Styling for the container stack
 */
export const containerStackTokens = (): IStackTokens => {
  return {
    childrenGap: 36,
  };
};

/**
 * Styling for the content stacks
 */
export const contentStackTokens = (): IStackTokens => {
  return { childrenGap: 24, padding: "0.5rem 0 0 0" };
};
